const ciConfigurationView = {
    bindings: {
        config: '<',
        selectedConfig: '<'
    },
    templateUrl:
      '/modules/modals/subsystem-modal/ci-configuration-view/ci-configuration-view.html',
    controller: 'CiConfigurationViewController',
};

angular
    .module('modalDirectives')
    .component('ciConfigurationView', ciConfigurationView);
